export enum BillPayTermsColumns {
	id = "Id",
	status = "Status",
	org = "Org",
	name = "Name",
	createdAt = "Created At",
}

export type AllowedBillPayTermsColumns =
	| BillPayTermsColumns.id
	| BillPayTermsColumns.status
	| BillPayTermsColumns.org
	| BillPayTermsColumns.name
	| BillPayTermsColumns.createdAt
